var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.activeComponent === 'main')?_c('ContextPluginMain',{on:{"setActiveComponent":_vm.setActiveComponent}}):_c('ContextPluginView',{on:{"setActiveComponent":_vm.setActiveComponent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }